import { ContactMail } from '../../Contact/ContactMail';
import { ContactPhone } from '../../Contact/ContactPhone';
import { FC } from 'react';
import { Link, Spacer } from 'internalLibrary';
import { TERMS_AND_CONDITIONS_URL } from 'config/app';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './DesktopFooter.module.scss';

export interface DesktopFooterProps {
  className?: string;
  content: {
    businessHours: string;
    email: string;
    phone: string;
    termsAndConditionsText?: string;
  };
  center?: boolean;
}

const DesktopFooter: FC = () => {
  const { t } = useTranslation();

  const termsAndConditionsText = t('termsAndConditionsText');
  const termsAndConditionsUrl = TERMS_AND_CONDITIONS_URL;

  return (
    <div className={classNames(styles.footer)}>
      <div className={styles.contact}>
        <div className={styles['contact-info']}>
          <ContactMail email={t('email')} />
          <Spacer marginRight={'30px'} />
          <ContactPhone phone={t('phone')} />
        </div>
        <div
          className={styles['business-hours']}
          dangerouslySetInnerHTML={{ __html: t('businessHours') }}
        />
      </div>
      <div className={styles['terms-conditions-wrapper']}>
        <Link
          className={styles['terms-conditions']}
          href="#"
          onClick={() => {
            window.open(termsAndConditionsUrl);
          }}
        >
          {termsAndConditionsText}
        </Link>
      </div>
    </div>
  );
};

export default DesktopFooter;
